module.exports = __webpack_public_path__ + "img/arrow-l.e81b15bf.svg";